import { HTTPClient } from "./Client";

const CursoMoodleApi = {

    async listarCursosMoodleAsync() {
        const response = await HTTPClient.get(`/CursoMoodle/listar-cursos-moodle`);
        return response.data;
    }
}

export default CursoMoodleApi;